import {
  GET_USERS, GET_TOKEN, TOKEN_ERROR, LOGOUT, GET_TIPOFALLA, GET_ASIGUSUARIO, GET_SEGUITICKET, GET_TICKHISTORIAL,
  ID_TICKET_HISTORIAL_SUCCESS, UPDATE_TICKET_STATUS_SUCCESS, GET_POSTREGISTROS, GET_AGENDA, DELETE_AGENDA, DELETE_AGENDA_ERROR, TICKET_ASIGNAR, TECNICO_TI, GET_USERS_ERROR,
  GET_ALLTICKETCED, GET_RESOLUCION, GET_ALLTICKUSER, GET_TODOSUSER, GET_CARGO, GET_AREA, GET_ROL, GET_EQUIPOS, GET_SO, GET_MARCA, GET_TIPOEQUI, GET_CRITICI, GET_ASIGEQUIPO, GET_CONSUMOS, GET_DATOXTEC,
  GET_EQUIPOSMTO, GET_APROBAR, GET_ALLTICKUSERMTO, TICKET_ASIGNARMTO, TECNICO_MTO, GET_ASIGNACIONES, GET_SEGUITICKETMTO, GET_EQUIPOSACT, UPDATE_ACTIVO_SUCCESS, UPDATE_ACTIVO_ERROR,
  GET_BAJAS, POST_BAJA_SUCCESS, POST_BAJA_ERROR, UPDATE_PERMISO_BAJA_SUCCESS, DECIDIR_BAJA_SUCCESS
} from "./actions";

const initialState = {
  usuario: JSON.parse(sessionStorage.getItem('usuario')) || [],
  token: { message: '' },
  tokenError: null,
  usuarioError: null, // Nuevo estado para manejar errores de usuario
  tipofalla: [],
  asigusuario: [],
  estadoticket: [],
  tickhistorial: [],
  tickhistorial: { registros: [] },
  tickregistro: [],
  agenda: [],
  agendaError: null,
  ticketasignar: [],
  tecnicoti: [],
  allticketced: [],
  resolucion: [],
  alltickuser: [],
  allusuarios: [],
  cargo: [],
  area: [],
  rol: [],
  equipos: [],
  sistemasOperativos: [],
  marca: [],
  tipoequipo: [],
  tipodeequipo: [],
  criticidad: [],
  asignaciones: [],
  consumo: [],
  datxtec: [],
  equiposmto: [],
  aprobar: [],
  alltickusermto: [],
  ticketasignarmto: [],
  tecnicomto: [],
  errorPost: null,
  asignaciones: [],
  seguimto: [],
  equiact: [],
  bajas: [],
  errorBaja: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return { ...state, usuario: action.payload, usuarioError: null };
    case GET_USERS_ERROR: // Nuevo caso para manejar el error
      return { ...state, usuarioError: action.payload };
    case GET_TOKEN:
      return { ...state, token: action.payload, tokenError: null };
    case TOKEN_ERROR:
      return { ...state, tokenError: action.payload };
    case LOGOUT:
      return { ...state, usuario: [], token: [] };
    case GET_TIPOFALLA:
      return { ...state, tipofalla: action.payload };
    case GET_ASIGUSUARIO:
      return { ...state, asigusuario: action.payload };
    case GET_SEGUITICKET:
      return { ...state, estadoticket: action.payload };
    case GET_TICKHISTORIAL:
      return { ...state, tickhistorial: action.payload };
    case ID_TICKET_HISTORIAL_SUCCESS:
      return { ...state, tickhistorial: action.payload };
    case UPDATE_TICKET_STATUS_SUCCESS:
      return {
        ...state,
        tickhistorial: {
          ...state.tickhistorial,
          registros: state.tickhistorial.registros.map((registro) =>
            registro.id === action.payload.id ? action.payload : registro
          ),
        },
      };
    case GET_POSTREGISTROS:
      return { ...state, tickregistro: action.payload };
    case GET_AGENDA:
      return { ...state, agenda: action.payload };
    case DELETE_AGENDA:
      return {
        ...state,
        agenda: state.agenda.filter(agenda => agenda.id !== action.payload),
        agendaError: null,
      };
    case DELETE_AGENDA_ERROR:
      return { ...state, agendaError: action.payload };
    case TICKET_ASIGNAR:
      return { ...state, ticketasignar: action.payload };
    case TECNICO_TI:
      return { ...state, tecnicoti: action.payload };
    case GET_ALLTICKETCED:
      // console.log("Payload de GET_ALLTICKETCED:", action.payload);
      return { ...state, allticketced: action.payload };
    case GET_RESOLUCION:
      return { ...state, resolucion: action.payload };
    case GET_ALLTICKUSER:
      return { ...state, alltickuser: action.payload };
    case GET_TODOSUSER:
      return { ...state, allusuarios: action.payload };
    case GET_CARGO:
      return { ...state, cargo: action.payload };
    case GET_AREA:
      return { ...state, area: action.payload };
    case GET_ROL:
      return { ...state, rol: action.payload };
    case GET_EQUIPOS:
      return { ...state, equipos: action.payload }
    case GET_SO:
      return { ...state, sistemasOperativos: action.payload }
    case GET_MARCA:
      return { ...state, marca: action.payload }
    case GET_TIPOEQUI:
      return { ...state, tipoequipo: action.payload }
    case 'GET_TIPODEEQUI':
      return { ...state, tipodeequipo: action.payload }
    case 'POST_TIPOEQUI':
      return { ...state, tipoequipo: [...state.tipoequipo, action.payload] }
    case 'POST_TIPODEEQUI':
      return { ...state, tipodeequipo: [...state.tipodeequipo, action.payload] }
    case GET_CRITICI:
      return { ...state, criticidad: action.payload }
    case GET_ASIGEQUIPO:
      return { ...state, asignaciones: action.payload }
    case GET_CONSUMOS:
      return { ...state, consumo: action.payload }
    case GET_DATOXTEC:
      return { ...state, datxtec: action.payload }
    case GET_EQUIPOSMTO:
      return { ...state, equiposmto: action.payload }
    case GET_APROBAR:
      return { ...state, aprobar: action.payload }
    case GET_ALLTICKUSERMTO:
      return { ...state, alltickusermto: action.payload }
    case TICKET_ASIGNARMTO:
      return { ...state, ticketasignarmto: action.payload };
    case TECNICO_MTO:
      return { ...state, tecnicomto: action.payload };
    case GET_ASIGNACIONES:
      return { ...state, asignaciones: action.payload };
    case GET_SEGUITICKETMTO:
      return { ...state, seguimto: action.payload };
    case GET_EQUIPOSACT:
      return { ...state, equiact: action.payload }
    case GET_BAJAS:
      return { ...state, bajas: action.payload };
    case POST_BAJA_SUCCESS:
      return { ...state, errorBaja: null };
    case POST_BAJA_ERROR:
      return { ...state, errorBaja: action.payload };
    case UPDATE_PERMISO_BAJA_SUCCESS:
      return {
        ...state,
        allusuarios: Array.isArray(state.allusuarios)
          ? state.allusuarios.map((u) =>
              u.id === action.payload.id ? { ...u, permisoBaja: action.payload.permisoBaja } : u
            )
          : {
              ...state.allusuarios,
              usuarios: (state.allusuarios.usuarios || []).map((u) =>
                u.id === action.payload.id ? { ...u, permisoBaja: action.payload.permisoBaja } : u
              ),
            },
      };
    case DECIDIR_BAJA_SUCCESS:
      return { ...state };
    case 'POST_EQUIPO_SUCCESS':
    case UPDATE_ACTIVO_SUCCESS:
      return {
        ...state,
        errorPost: null,        // limpiar error
      };
    case 'POST_EQUIPO_ERROR':
    case UPDATE_ACTIVO_ERROR:
      return {
        ...state,
        errorPost: action.payload,   // mensaje "el código ya existe" o error de red
      };
    default:
      return state;
  }
};

export default rootReducer;
